import React from 'react'
import { useWindowSize } from 'src/app/hooks'

interface CustomColorInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  placeholder: string
  value?: string
  width?: number
  heigth?: number
}

const CustomColorInput: React.FC<CustomColorInputProps> = (props) => {
  const { placeholder, value = null, width = 100, heigth = 60, ...restProps } = props
  const { isMobile } = useWindowSize()

  return <input
    type='color'
    value={value}
    className='ant-input'
    placeholder={placeholder}
    style={{
      width: `${width}px`, height: `${heigth}px`,
      cursor: 'pointer', position: 'relative', top: isMobile ? '2px' : '-10px'
    }}
    {...restProps}
  />
}

export default CustomColorInput
